var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.path},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.item.object_id))])}
var staticRenderFns = []

export { render, staticRenderFns }